
export const InvestorBenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: '높은 수익성',
      description: '연간 30% 이상의 예상 ROI와 지속적인 성장 가능성',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: '안정성 보장',
      description: '정부 인증과 국제 특허로 보호받는 안정적인 투자',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-earth-line',
      title: 'ESG 투자',
      description: '환경과 사회에 기여하는 지속가능한 투자 기회',
      color: 'bg-emerald-500'
    },
    {
      icon: 'ri-rocket-line',
      title: '성장 잠재력',
      description: '글로벌 바이오 시장 확장과 함께 성장하는 기업',
      color: 'bg-purple-500'
    }
  ];

  const milestones = [
    {
      year: '2024',
      title: 'Series A 펀딩 완료',
      amount: '$2.5M',
      description: '제품 상용화 및 생산 확대'
    },
    {
      year: '2025',
      title: '해외 시장 진출',
      amount: '$10M',
      description: '북미 및 유럽 시장 진출'
    },
    {
      year: '2026',
      title: '대량 생산 체제',
      amount: '$25M',
      description: '아시아 전 지역 생산 네트워크 구축'
    },
    {
      year: '2027',
      title: 'IPO 준비',
      amount: '$100M+',
      description: '기업공개 및 글로벌 상장'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            투자자 혜택 및 성장 로드맵
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            MarineBioGroup 투자자들이 받을 수 있는 다양한 혜택과 장기적인 성장 계획을 확인하세요.
          </p>
        </div>

        {/* 투자자 혜택 */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <div className={`w-16 h-16 ${benefit.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* 성장 로드맵 */}
        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            성장 로드맵 & 예상 밸류에이션
          </h3>
          
          <div className="grid md:grid-cols-4 gap-8">
            {milestones.map((milestone, index) => (
              <div key={index} className="relative">
                {/* 연결선 */}
                {index < milestones.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-full w-full h-0.5 bg-blue-300 transform translate-x-0 z-0"></div>
                )}
                
                <div className="relative bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow z-10">
                  <div className="text-center mb-4">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-600 text-white rounded-full font-bold text-lg mb-3">
                      {index + 1}
                    </div>
                    <div className="text-2xl font-bold text-blue-600">{milestone.year}</div>
                  </div>
                  
                  <h4 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                    {milestone.title}
                  </h4>
                  
                  <div className="text-2xl font-bold text-green-600 text-center mb-3">
                    {milestone.amount}
                  </div>
                  
                  <p className="text-sm text-gray-600 text-center">
                    {milestone.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 투자 수익 시뮬레이션 */}
        <div className="mt-16 bg-gray-900 text-white rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-center mb-12">투자 수익 시뮬레이션</h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 border border-gray-700 rounded-xl">
              <div className="text-lg text-gray-300 mb-2">$10,000 투자 시</div>
              <div className="text-4xl font-bold text-green-400 mb-2">$43,000</div>
              <div className="text-sm text-gray-400">3년 후 예상 가치</div>
              <div className="text-xl font-semibold text-blue-400 mt-2">+330% 수익</div>
            </div>
            
            <div className="text-center p-6 border border-gray-700 rounded-xl">
              <div className="text-lg text-gray-300 mb-2">$50,000 투자 시</div>
              <div className="text-4xl font-bold text-green-400 mb-2">$215,000</div>
              <div className="text-sm text-gray-400">3년 후 예상 가치</div>
              <div className="text-xl font-semibold text-blue-400 mt-2">+330% 수익</div>
            </div>
            
            <div className="text-center p-6 border border-gray-700 rounded-xl">
              <div className="text-lg text-gray-300 mb-2">$100,000 투자 시</div>
              <div className="text-4xl font-bold text-green-400 mb-2">$430,000</div>
              <div className="text-sm text-gray-400">3년 후 예상 가치</div>
              <div className="text-xl font-semibold text-blue-400 mt-2">+330% 수익</div>
            </div>
          </div>
          
          <p className="text-center text-gray-400 text-sm mt-8">
            * 위 수치는 예상치이며 실제 수익과 다를 수 있습니다. 투자에는 위험이 따릅니다.
          </p>
        </div>
      </div>
    </section>
  );
};
